module.exports = __webpack_public_path__ + "static/media/home.55644be0.svg";